export default __webpack_public_path__ + "static/media/mob_station_stations.53b02037.png";